export default "__VITE_ASSET__BJtUypSQ__"